import React, { useEffect, useState } from 'react';
import { wire } from 'react-hot-wire';
import { FormattedMessage } from 'react-intl';

import View from 'components/_/common/view/list/ListView';

import { ItemList } from './ItemList';

function ItemListView(props) {
	const storeItemService = props['services.storeItemService'];
	const {
		match: {
			params: { tag },
		},
	} = props;
	const [tags, setTags] = useState([]);

	useEffect(() => {
		(async () => {
			setTags(await storeItemService.fetchTagList());
		})();
	}, [setTags, storeItemService]);

	return (
		<View
			name="prizeList"
			i18nKey="prize-list"
			config={{
				search: false,
			}}
			tabs={{
				url: '/store/${tab}', // eslint-disable-line no-template-curly-in-string
				list: [
					{
						tab: 'all',
						content: <FormattedMessage id="prize-list.all-tab" />,
					},
					...tags.map(_tag => ({
						tab: _tag.name,
						content: _tag.description,
					})),
				],
			}}
		>
			<ItemList tag={tag} storeItemService={storeItemService} />
		</View>
	);
}

export default wire(['services.storeItemService'], ItemListView);
